import { Helmet } from "react-helmet-async";
import React from "react";

type SEOProps = {
  title: string;
  description: string;
  canonicalUrl?: string;
};

const SEO: React.FC<SEOProps> = ({ title, description, canonicalUrl }) => {
  return (
    <Helmet> 
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}

export default SEO;